import { formTranslation } from "@/Shared/ui/sharedTranslation"
import { OreButton, OreHeading, OreModal, OreModalBox, OreModalBoxBody, OreModalBoxFooter, OreText } from "@edenredespana/oreneta"
import { forwardRef, useImperativeHandle, useState } from "react"
import { useTranslation } from "react-i18next"
import { LoginTranslation } from "../accountTranslation"
import { useNavigate } from "react-router-dom"
import { openNavigationRoutes } from "@/Shared/ui/routers"

export type CancelCreateAccountModalType = {
  open: () => void
}

export const CancelCreateAccountModal = forwardRef<CancelCreateAccountModalType>((_, ref): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()
     const [open, setOpen] = useState<boolean>(false)

    useImperativeHandle(ref, () => ({
        open: async (): Promise<void> => {
          setOpen(true)
        },
    }))

const saveAndClose = async (
    event: React.MouseEvent<HTMLButtonElement>,
): Promise<void> => {
    navigate(openNavigationRoutes.login)
    event?.preventDefault()
}
    return(
        <OreModal open={open} handleOnClose={() => setOpen(false)}>
              <OreModalBox size="medium" handleOnClose={() => setOpen(false)}>
                <OreModalBoxBody>
                  <OreHeading size="headline-lg">
                    {t(LoginTranslation.register.basicForm.modalTitle)}
                  </OreHeading>
                  <OreText>{t(LoginTranslation.register.basicForm.modalDescription)}</OreText>
                </OreModalBoxBody>
                <OreModalBoxFooter>
                  <OreButton onClick={() => setOpen(false)}  size="small" category="secondary">
                    {t(formTranslation.common.buttons.cancel)}
                  </OreButton>
                  <OreButton onClick={saveAndClose}  size="small" category="primary">
                    {t(LoginTranslation.register.basicForm.modalOk)}
                  </OreButton>
                </OreModalBoxFooter>
              </OreModalBox>
            </OreModal>
    )
})